import {
  USERS_SET,
  USER_INFO_SET,
  USER_NAMES_SET,
  USER_CREATE_INFO_SET,
  USER_CREATE_INFO_CLEAR,
  USER_CREATE_ERROR,
  USER_CLEAR_ERROR
} from '../constants/action_constants';
import { newAlert } from './alert_actions';
import { setCurrentUser, login } from './authentication_actions';
import RequestService from '../services/request_service';
import AxiosRequest from '../services/axios_request';
import AxiosNodeRequest from '../services/axios_node_request';
import { sendRequest, completeRequest, errorOnRequest } from './request_state';
import { stringifyQuery } from '../helpers/parseQuerystring';
import { history } from '../helpers/history';
import userFiltersSanitizer from '../helpers/sanitizers/userFilters';
import { fetchPointsOfSaleNamesAssociation } from './points_of_sale_actions';
const requestService = new RequestService();
const requestServiceNode = new RequestService('node');
const axiosRequest = new AxiosRequest();
const axiosNodeRequest = new AxiosNodeRequest();

//* PURE ACTION FUNCTIONS

function setUsers(items, pagi) {
  return {
    type: USERS_SET,
    data: items,
    meta: pagi
  };
}

export function setUserNames(items) {
  return {
    type: USER_NAMES_SET,
    data: items
  };
}

function setUserInfo(info) {
  return {
    type: USER_INFO_SET,
    data: info
  };
}

function updateUserState(user) {
  return user.isCurrentUser ? setCurrentUser(user) : setUserInfo(user);
}

export function setCreationInfo(info) {
  return {
    type: USER_CREATE_INFO_SET,
    data: info
  };
}

export function clearCreationInfo() {
  return {
    type: USER_CREATE_INFO_CLEAR,
    data: null
  };
}

export function userCreateError(errors) {
  return {
    type: USER_CREATE_ERROR,
    errors
  };
}

export function userClearError() {
  return {
    type: USER_CLEAR_ERROR,
    data: null
  };
}

//* VIEW ACTION FUNCTIONS
export const fetchUsers = (params = {}, route) => async dispatch => {
  dispatch(sendRequest());
  history.replace(`${route}?${stringifyQuery(params)}`);
  const blocked = route === '/black-list' ? 'true' : 'false';
  try {
    const payload = await requestServiceNode.get(
      'users',
      userFiltersSanitizer({ ...params, blocked })
    );
    dispatch(setUsers(payload.data, payload.meta));
  } catch (errors) {
    // console.log(errors);
  } finally {
    dispatch(completeRequest());
  }
};

export const fetchUserNames = id => async dispatch => {
  dispatch(sendRequest('UserNames'));
  try {
    const payload = await requestServiceNode.get(
      `users/usersToPointOfSale/${id}`
    );
    dispatch(setUserNames(payload.data));
  } catch (errors) {
    errors.json().then(e => {
      dispatch(newAlert('error', 'ERROR:', e.errors.base));
    });
  } finally {
    dispatch(completeRequest('UserNames'));
  }
};

export const fetchUserInfo = id => async dispatch => {
  dispatch(sendRequest('UserDetail'));
  try {
    const payload = await requestServiceNode.get(`users/${id}`);
    dispatch(setUserInfo(payload.data));
    dispatch(fetchPointsOfSaleNamesAssociation({ id }));
    return { success: true };
  } catch (errors) {
    // console.log(errors);
    const e = await errors.json();
    e && e.message && dispatch(newAlert('error', 'ERROR:', e.message));
    return { success: false };
  } finally {
    dispatch(completeRequest('UserDetail'));
  }
};

export const relatePointOfSalesToUser = (
  params = {},
  user
) => async dispatch => {
  dispatch(sendRequest('UpdatePointOfSalesOfUser'));
  try {
    const payload = await requestServiceNode.put(
      'users/relatePointOfSalesToUser',
      params
    );
    user.pointOfSales = payload.data.pointOfSales;
    dispatch(updateUserState(user));

    dispatch(newAlert('success', 'sucess', payload.data.message));
    dispatch(completeRequest('UpdatePointOfSalesOfUser'));
  } catch (errors) {
    const e = await errors.json();
    e && e.errors && dispatch(newAlert('error', 'ERROR:', e.errors.base));
  } finally {
    dispatch(completeRequest('UpdatePointOfSalesOfUser'));
  }
};

export const fetchUserSessionData = user => async dispatch => {
  dispatch(sendRequest('FetchUserSessionData'));
  try {
    const payload = await requestServiceNode.get(`sessions`);
    const userInfo = { ...payload.data.attributes };
    delete userInfo.token;
    const newCurrentUserData = {
      data: Object.assign(user, userInfo)
    };
    dispatch(setCurrentUser(Object.assign(user, userInfo)));
  } catch (errors) {
    // console.log(errors);
    const e = await errors.json();
    e && e.message && dispatch(newAlert('error', 'ERROR:', e.message));
  } finally {
    dispatch(completeRequest('FetchUserSessionData'));
  }
};

export const validateUser = (params = {}) => async dispatch => {
  dispatch(sendRequest('NewUser'));
  try {
    dispatch(userClearError());
    const payload = await axiosNodeRequest.post('users/validate', params);
    dispatch(setCreationInfo(payload.data));
  } catch (error) {
    if (error.errors) {
      dispatch(userCreateError(error.errors));
      if (error.errors.base) {
        dispatch(newAlert('error', 'ERROR:', error.errors.base));
      }
    } else {
      dispatch(
        newAlert(
          'error',
          'ERROR:',
          'Hubo un error procesando su solicitud, por favor comuniquese con sistemas.'
        )
      );
    }
    dispatch(errorOnRequest('NewUser', error.message));
  } finally {
    dispatch(completeRequest('NewUser'));
  }
};

export const createUser = (params = {}) => async dispatch => {
  dispatch(sendRequest('NewUser'));
  try {
    const payload = await axiosNodeRequest.post('users', params);
    if (payload.status === 'success') {
      dispatch(newAlert('success', 'success', payload.data.message));
    }

    return true;
  } catch (errors) {
    const e = await errors;
    if (e.errors) {
      if (e.errors.base) {
        dispatch(newAlert('error', 'ERROR:', e.errors.base));
      }
    }
    dispatch(errorOnRequest('NewUser', e.message));
  } finally {
    dispatch(completeRequest('NewUser'));
  }
};

export const restart2Factor = (params = {}) => async dispatch => {
  dispatch(sendRequest('Restart2fa'));
  try {
    const payload = await axiosNodeRequest.post('users/restart2Factor', params);
    if (payload.status === 'success') {
      dispatch(newAlert('success', 'success', payload.data.message));
    }
    return true;
  } catch (errors) {
    const e = await errors;
    if (e.errors) {
      if (e.errors.base) {
        dispatch(newAlert('error', 'ERROR:', e.errors.base));
      }
    }
    dispatch(errorOnRequest('Restart2fa', e.message));
  } finally {
    dispatch(completeRequest('Restart2fa'));
  }
};

export const updateEnabled2Factor = (params = {}) => async dispatch => {
  dispatch(sendRequest('Restart2fa'));
  try {
    const payload = await axiosNodeRequest.post(
      'users/updateEnabled2Factor',
      params
    );
    if (payload.status === 'success') {
      dispatch(newAlert('success', 'success', payload.data.message));
    }
    return true;
  } catch (errors) {
    const e = await errors;
    if (e.errors) {
      if (e.errors.base) {
        dispatch(newAlert('error', 'ERROR:', e.errors.base));
      }
    }
    dispatch(errorOnRequest('Restart2fa', e.message));
  } finally {
    dispatch(completeRequest('Restart2fa'));
  }
};

export const updateUserPictureProfile = (
  user,
  params = {}
) => async dispatch => {
  dispatch(sendRequest('UpdateUserPictureProfile'));
  try {
    const payload = await requestServiceNode.put(
      `users/${user.id}/updatePictureProfile`,
      params,
      {},
      true
    );
    dispatch(updateUserState(user));
    dispatch(newAlert('success', 'sucess', payload.data.message));
  } catch (errors) {
    const e = await errors.json();
    e.message && dispatch(newAlert('error', 'error', e.message));
    dispatch(errorOnRequest('UpdateUserPictureProfile', e.message));
  } finally {
    dispatch(completeRequest('UpdateUserPictureProfile'));
  }
};

export const deletePictureProfile = (user, params = {}) => async dispatch => {
  dispatch(sendRequest('DeletePictureProfile'));
  try {
    const payload = await requestServiceNode.delete(
      `users/${user.id}/deletePictureProfile`,
      params,
      {},
      true
    );
    dispatch(updateUserState(user));
    dispatch(newAlert('success', 'sucess', payload.data.message));
  } catch (errors) {
    const e = await errors.json();
    e.message && dispatch(newAlert('error', 'error', e.message));
    dispatch(errorOnRequest('DeletePictureProfile', e.message));
  } finally {
    dispatch(completeRequest('DeletePictureProfile'));
  }
};

export const updateRoles = (params = {}, user) => async dispatch => {
  dispatch(sendRequest('UpdateRoles'));
  try {
    const payload = await requestServiceNode.put(`users/updateRoles`, params);
    user = Object.assign(user, payload.data);

    dispatch(updateUserState(user));

    dispatch(newAlert('success', 'sucess', payload.message));
  } catch (errors) {
    const e = await errors.json();
    e.message && dispatch(newAlert('error', 'error', e.message));
    dispatch(errorOnRequest('UpdateRoles', e.message));
  } finally {
    dispatch(completeRequest('UpdateRoles'));
  }
};

export const updateUser = (user, params = {}, type = '') => async dispatch => {
  dispatch(sendRequest(type));
  try {
    const payload = await requestServiceNode.put(`users/${user.id}`, {
      ...params,
      type
    });
    user = Object.assign(user, payload.data);

    dispatch(updateUserState(user));
    dispatch(newAlert('success', 'sucess', payload.message));
    return { success: true };
  } catch (errors) {
    const e = await errors.json();

    if (e.errors && e.errors.base) {
      dispatch(newAlert('error', 'error', e.errors.base));
      dispatch(errorOnRequest('UpdateUser', e.errors.base));
    }

    return { success: false };
  } finally {
    dispatch(completeRequest(type));
  }
};

export const updatePassword = (user, params = {}) => async dispatch => {
  dispatch(errorOnRequest('UpdatePassword', {}));
  dispatch(sendRequest('UpdatePassword'));
  try {
    const payload = await requestServiceNode.put(
      'users/updatePasswordWithToken',
      params
    );
    user = Object.assign(user, payload.data.user);
    dispatch(updateUserState(user));
    dispatch(newAlert('success', 'sucess', payload.data.message));
    return true;
  } catch (errors) {
    const e = await errors.json();

    e &&
      e.errors &&
      e.errors.base &&
      dispatch(newAlert('error', 'ERROR:', e.errors.base));

    e && e.errors && dispatch(errorOnRequest('UpdatePassword', e.errors));
    return false;
  } finally {
    dispatch(completeRequest('UpdatePassword'));
  }
};

export const confirmUserEmail = (params, type = '') => async dispatch => {
  dispatch(sendRequest(type));
  try {
    dispatch(userClearError());
    const payload = await requestServiceNode.post(
      'users/confirmUserEmail',
      params
    );
    dispatch(login(payload.data.email, params.password));
    dispatch(newAlert('success', 's', 'Contraseña establecida exitosamente'));
  } catch (errors) {
    const e = await errors.json();
    if (e.errors) {
      dispatch(errorOnRequest('UpdatePassword', e.errors));
      if (e.errors.base) {
        dispatch(newAlert('error', 'ERROR:', e.errors.base));
      }
    }
  } finally {
    dispatch(completeRequest(type));
  }
};

export const updateMedia = (user, params = {}, type = '') => async dispatch => {
  dispatch(sendRequest(type));
  try {
    await requestServiceNode.put(
      `users/${user.id}/updateMedia`,
      params,
      {},
      true
    );
    return true;
  } catch (errors) {
    const e = await errors.json();
    e && e.errors && dispatch(errorOnRequest('UpdateMedia', e.errors));

    if (e.errors.base) {
      dispatch(newAlert('error', 'ERROR:', e.errors.base));
    } else if (e.errors) {
      dispatch(newAlert('error', 'ERROR:', e.errors));
    }
    return false;
  } finally {
    dispatch(completeRequest(type));
  }
};

export const resendConfirmationEmail = user => async dispatch => {
  dispatch(sendRequest('ResendConfirmationEmail'));
  try {
    const payload = await requestServiceNode.post(
      `users/resendConfirmationEmail`,
      {
        id: user.id
      }
    );
    dispatch(newAlert('success', 'success', payload.data.message));
  } catch (errors) {
    const e = await errors.json();
    e &&
      e.errors &&
      dispatch(errorOnRequest('ResendConfirmationEmail', e.errors));
  } finally {
    dispatch(completeRequest('ResendConfirmationEmail'));
  }
};

export const confirmUpdateMedia = (
  user,
  params,
  type = ''
) => async dispatch => {
  dispatch(sendRequest(type));
  try {
    const payload = await requestServiceNode.put(
      `users/${user.id}/confirmMediaUpdating`,
      params,
      {},
      true
    );
    dispatch(updateUserState(user));
    dispatch(newAlert('success', 'success', payload.data.message));
    return true;
  } catch (errors) {
    const e = await errors.json();
    if (e.errors.base) {
      dispatch(newAlert('error', 'ERROR:', e.errors.base));
    } else if (e.errors) {
      dispatch(newAlert('error', 'ERROR:', e.errors));
    }
    return false;
  } finally {
    dispatch(completeRequest(type));
  }
};
